import React from "react";
import { DataTableStyles } from "styles/style";

export default function DataTable({ data, columns, onEdit, onAdd, title }) {
  return (
    <DataTableStyles.DataTableContainer>
      <DataTableStyles.DataTableHeader>
        <DataTableStyles.DataTableAddButton 
          type="button" 
          onClick={onAdd}
        >
          Add New
        </DataTableStyles.DataTableAddButton>
      </DataTableStyles.DataTableHeader>
      
      {data.length === 0 ? (
        <DataTableStyles.DataTableEmptyState>
          No entries found. Click "Add New" to create your first entry.
        </DataTableStyles.DataTableEmptyState>
      ) : (
        <DataTableStyles.DataTableWrapper>
          <DataTableStyles.DataTable>
            <DataTableStyles.DataTableHead>
              <DataTableStyles.DataTableHeaderRow>
                {columns.map((col, index) => (
                  <DataTableStyles.DataTableHeaderCell key={index}>
                    {col.header}
                  </DataTableStyles.DataTableHeaderCell>
                ))}
                <DataTableStyles.DataTableHeaderCell>Actions</DataTableStyles.DataTableHeaderCell>
              </DataTableStyles.DataTableHeaderRow>
            </DataTableStyles.DataTableHead>
            <DataTableStyles.DataTableBody>
              {data.map((row, rowIndex) => (
                <DataTableStyles.DataTableRow key={rowIndex}>
                  {columns.map((col, colIndex) => (
                    <DataTableStyles.DataTableCell key={colIndex}>
                      {row[col.key] || '-'}
                    </DataTableStyles.DataTableCell>
                  ))}
                  <DataTableStyles.DataTableCell>
                    <DataTableStyles.DataTableEditButton
                      onClick={() => onEdit(row, rowIndex)}
                    >
                      Edit
                    </DataTableStyles.DataTableEditButton>
                  </DataTableStyles.DataTableCell>
                </DataTableStyles.DataTableRow>
              ))}
            </DataTableStyles.DataTableBody>
          </DataTableStyles.DataTable>
        </DataTableStyles.DataTableWrapper>
      )}
    </DataTableStyles.DataTableContainer>
  );
}